//Function Name
export const PRE_SIGNUP = 'arn:aws:lambda:ap-south-1:079693644758:function:userVerification'
export const API_KEY = '8kv30L0lwk9fnd2HAkl9s9dv7NNQwCdrG0a2wwr1'
export const AWS_PINPOINT_PROJECT_ID = '191295cceae343feaad4db428c20f7e8'

export const APP_NAME = 'Dripset'